import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { I18nextProvider, useTranslation } from 'react-i18next';
import i18n from './i18n'; // مسیر درست
import Login from './pages/Login';
import Home from './pages/Home';
import Profile from './pages/Profile';
import Signals from './pages/Signals';
import Subscribers from './pages/Subscribers';

const App = () => {
  const { i18n: i18nInstance } = useTranslation();

  useEffect(() => {
    document.body.setAttribute('dir', i18nInstance.language === 'fa' ? 'rtl' : 'ltr');
  }, [i18nInstance.language]);

  return (
    <I18nextProvider i18n={i18n}>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/home" element={<Home />} />
          <Route path="/subscribers" element={<Subscribers />} />
          <Route path="/signals" element={<Signals />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="*" element={<div>Not Found</div>} />
        </Routes>
      </Router>
    </I18nextProvider>
  );
};

export default App;